var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataGetter',{attrs:{"url":_vm.url,"params":{
    ..._vm.baseParams,
    Country: _vm.countries,
    CODE_YEAR: _vm.year,
  },"initialData":[],"lazy":"","child-element-type":null},on:{"fetched":_vm.setUnits},scopedSlots:_vm._u([{key:"default",fn:function({ data }){return [_c('DataSlicer',{attrs:{"data":data,"dataFormatter":_vm.sortData,"yAxisDimension":"Product","xAxisDimension":"Country","valueDimension":"Value","child-element-type":null},on:{"sliced":_vm.setProductName},scopedSlots:_vm._u([{key:"default",fn:function({ slicedData }){return [_c('Chart',{attrs:{"title":`${_vm.productName} prices, ${_vm.country} vs. selected countries and regions, ${_vm.year}`,"units":_vm.units,"chartType":"bar","half":_vm.half,"series":slicedData,"chartOptions":{
        chart: {
          height: 400,
          spacing: 10,
          margin: [30, 0, 0, 200],
        },
        xAxis: {
          type: 'category',
          labels: {
            formatter() {
              return this.value === _vm.country
                ? `<b>${this.value}</b>`
                : this.value;
            },
          },
        },
        yAxis: {
          opposite: true,
          tickAmount: 6,
        },
      }}})]}}],null,true)})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }